<template>
  <div class="income-chart" id="income-chart">
    <div class="homepage-title">
      <el-tooltip class="item" placement="bottom" :open-delay="delay" popper-class="atooltip">
        <div slot="content">
          总收入=服务费+电费<br />服务费=订单服务费总和<br />电费=订单电费总和
        </div>
        <span class="title-n">收入曲线</span>
      </el-tooltip>
      <div style="flex-grow: 3"></div>
      <div class="right-btn">
        <span :class="[active == 1 ? 'active' : '']" @click="dateClick(1)"
          >日</span
        >
        <span>/</span>
        <span :class="[active == 2 ? 'active' : '']" @click="dateClick(2)"
          >月</span
        >
      </div>
    </div>
    <div id="income-line2" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import { type } from "os";
import { debug, debuglog } from "util";
export default {
  data() {
    return {
      width: "",
      active: 1,
      list: {},
      delay:1000
    };
  },
  mounted() {
    window.onresize = null;

    this.$nextTick(function () {
      this.getEchartData();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
  },
  destroyed() {
    window.onresize = null;
  },
  computed: {
    isChangeMsg() {
      return this.$store.state.collapse;
    },
    screenWidth() {
      return document.body.clientWidth;
    },
  },
  watch: {
    isChangeMsg(val) {
      let echart = echarts.init(document.getElementById("income-line2"));
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        setTimeout(function () {
          echart.resize();
        }, 0);
      }, 100);
    },
  },
  methods: {
    getEchartData(data) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getDayMonthPowerServFee",
      };
      this.$api({
        method: "post",
        url: "/api.php/Overview/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // let su=this.$store.state.getDayMonthPowerServFee
          if (su.data.code == 1) {
            this.list = su.data.list;
            // console.log(this.list);
            this.drawChart(this.list.day);
            // debugger
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    drawChart(data) {
      clearInterval(this.timer);
      clearInterval(this.timer1);
      // debugger
      // this.$store.state.collapse
      var series = JSON.parse(JSON.stringify(data));
      var legendData = [];
      var power_fee = [];
      var serv_fee = [];
      var date = [];
      for (let i = 0; i < series.length; i++) {
        legendData.push(series[i].total_fee);
        date.push(series[i].date);
        power_fee.push(series[i].power_fee);
        serv_fee.push(series[i].serv_fee);
      }
      // console.log(legendData);
      //  legendData = [0, 0, 0, 4670000000.06, 3206000000.88, 67.29];
      // debugger
      let echart = echarts.init(document.getElementById("income-line2"));
      var option = {
        color: ["#4D91FF", "#F8581E", "#F7F01C"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            // return
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValue + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "总收入") {
                txtCon +=
                  arr[i].marker +
                  "总收入" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              } else if (arr[i].seriesName == "服务费") {
                txtCon +=
                  arr[i].marker +
                  "服务费" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              } else if (arr[i].seriesName == "电费") {
                txtCon +=
                  arr[i].marker +
                  "电费" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              }
            }
            return txtCon;
          },
        },
        legend: {
          // orient: 'vertical',
          bottom: 8,
          textStyle: { color: "#FFFDFE" },
          left: "center",
          itemWidth: 15, // 图例图形宽度
          itemHeight: 8,
          // itemGap: 0,
          data: [
            {
              name: "总收入",
              // icon: "circle",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "服务费",
              // icon: "arrow",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "电费",
              // icon: "pin",
              textStyle: {
                fontSize: "12px",
              },
            },
          ],
        },
        grid: {
          containLabel: true,
          top: "22%", //距上边距
          bottom: "10%", //距离下边距
          right: "3%",
          left: "1%",
        },
        xAxis: {
          type: "category",
          data: date,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        series: [
          {
            name: "总收入",
            type: "line",
            barWidth: 18, //柱图宽度
            data: legendData,
            symbol: "none", //去除折线折点处圆点
            smooth: true,
          },
          {
            name: "服务费",
            data: serv_fee,
            type: "bar",
            barWidth: 18, //柱图宽度
          },
          {
            name: "电费",
            data: power_fee,
            type: "bar",
            barWidth: 18, //柱图宽度
          },
        ],
      };
      echart.setOption(option);
      // debugger
    },
    dateClick(num) {
      // debugger
      this.active = num;
      if (num == 1) {
        this.drawChart(this.list.day);
      } else if (num == 2) {
        this.drawChart(this.list.month);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.income-chart {
  width: calc(100% - 14px);
  height: 100%;
  position: relative;
  padding-left: 14px;
  .homepage-title {
    width: 70%;
    display: flex;
    left: 26px;
    .title-n {
      color: #fffffd;
      flex-grow: 1;
      z-index: 999;
    }
  }
  .right-btn {
    display: inline-block;
    flex-grow: 1;
    z-index: 999;
    span {
      color: #006EAE;
      cursor: pointer;
    }
    span.active {
      color: #ABE3FE;
    }
  }
  canvas {
    left: 12px !important;
  }
}
@media screen and (max-width: 1500px) {
  .income-chart {
    .homepage-title {
      font-size: 12px;
      top: 7px;
      left: 17px;
    }
  }
}
</style>
<style>
  .atooltip {
  background:rgba(50,50,50,0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/displayScreen/incomeChart.vue